module.exports = __webpack_public_path__ + "static/feedback-63add611ffeff154d71b9f69b29af88d.jpg";